import apiClient, {errorHandling, errorConsole} from '../apiClient';

const postulacionesParaAdminsServices = {
  obtenerPostulaciones: async (sortBy='') => {
    try {
      const response = await apiClient.get(`/postulaciones?sortBy=`+sortBy);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  obtenerEstados: async () => {
    try {
      const response = await apiClient.get(`/postulaciones/obtenerEstados`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  actualizarPostulacion: async (id, params, isMultipart = false) => {
    try {
      let headers = {}
      if(isMultipart){
        headers = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      }

      const response = await apiClient.put(`/postulaciones/${id}`, params, headers);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarPostulacion: async (id) => {
    try {
      const response = await apiClient.delete(`/postulaciones/${id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarAdjuntoPuntaje: async (id, adjunto_id) => {
    try {
      const response = await apiClient.delete(`/postulaciones/${id}/eliminarAdjuntoPuntaje/${adjunto_id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  eliminarAdjuntoPostulacion: async (id, adjuntos_postulacion_id) => {
    try {
      const response = await apiClient.delete(`/postulaciones/${id}/eliminarAdjuntoPostulacion/${adjuntos_postulacion_id}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  ordenDeMerito: async (es_publico) => {
    try {
      const response = await apiClient.get(`/postulaciones/${es_publico ? 'ordenDeMeritoPublico' : 'ordenDeMerito'}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  listaAdmisibles: async (es_publico) => {
    try {
      const response = await apiClient.get(`/postulaciones/${es_publico ? 'listaAdmisiblesPublicos' : 'listaAdmisibles'}`);

      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default postulacionesParaAdminsServices;
